import { Injectable } from '@angular/core';
import { ProjectService } from './project.service';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  constructor(private projectService:ProjectService) { }
  load(){
    this.projectService.getItems().subscribe((data)=>{
      localStorage.setItem("project_id",data.data[0]._id);
    })
  }
}
